import {Injectable} from '@angular/core';
import {PaymentRequestSummaryModel} from '../../../api/entity/paymentRequestSummary.model';
import {PaymentRequestSummaryConverter} from '../../../api/entity/converter/paymentRequestSummary.converter';
import {PaymentRequestModel} from '../../../api/entity/paymentRequest.model';
import {PaymentRequestDataService} from './PaymentRequestData.service';
import {
    AbstractDataServiceDtoSummaryAdapter
} from '../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';

@Injectable({providedIn: 'root'})
export class PaymentRequestSummaryDataServiceAdapter
    extends AbstractDataServiceDtoSummaryAdapter<PaymentRequestSummaryModel,
        PaymentRequestSummaryConverter, PaymentRequestModel> {
    constructor(dataService: PaymentRequestDataService, converter: PaymentRequestSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): PaymentRequestModel {
        return new PaymentRequestModel();
    }
}
